import * as React from 'react';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import { lightDefaultColor } from '../utils/constants';



export default function HeaderFab(props:{ title: string, onclick: React.MouseEventHandler<HTMLButtonElement> }) {
  return (
    <Fab variant="extended"
      aria-label="add"
      color="default"
      style={{ position: 'fixed', top: 14, right: 16, zIndex: 1200, backgroundColor:lightDefaultColor, color: 'black' }}
      size="small"
      onClick={props.onclick}
    >
      <AddIcon sx={{ mr: 1 }}/>
      {props.title}
    </Fab>
  );
}